import script from "./ClckWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClckWidget.vue?vue&type=script&setup=true&lang=ts"

import "./ClckWidget.vue?vue&type=style&index=0&id=ab7a5704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab7a5704"]])

export default __exports__